import { Option } from '@/components/inputs/AutocompleteInput';
import { useGetAvailableAmendmentsQuery } from '../services';
import type { AmendmentTransition } from '../models';
import { useMemo } from 'react';

export const useAvailableAmendments = (shippingNumber: number | null) => {
  const { data, isLoading } = useGetAvailableAmendmentsQuery(shippingNumber!, {
    skip: shippingNumber == null,
  });

  const amendmentOptions: Option[] = useMemo(
    () =>
      (data ?? []).map((transition) => ({
        label: transition.name,
        data: transition,
      })),
    [data]
  );

  const getAmendmentData = (option: Option | null): AmendmentTransition | null => {
    if (!option) return null;
    return option.data as AmendmentTransition;
  };

  return {
    amendmentOptions,
    isLoading,
    getAmendmentData,
  };
};
